import { createContext, useContext } from "react";

/** Where a More/Settings child screen goes when its inline back arrow is pressed.
 *  Screens with their own drill-down pass `onBack` to SecondaryHeading instead. */
export const SecondaryBackContext = createContext<(() => void) | null>(null);

export function useSecondaryBack() {
  return useContext(SecondaryBackContext);
}
